import React, { useState } from "react";

import CountriesMapCard from "./CountriesMapCard";
import CountriesRankedCard from "./CountriesRankedCard";

import type { JSX, ReactNode } from "react";

import type { DashboardPeriodProps, MapView } from "./dashboard.types";

interface CountriesSectionProps extends DashboardPeriodProps {
  children: ReactNode;
}

function CountriesSection({
  period,
  children,
}: CountriesSectionProps): JSX.Element {
  const [view, setView] = useState<MapView>("views");

  return (
    <React.Fragment>
      <CountriesMapCard onViewChange={setView} period={period} view={view} />
      <div className="grid gap-4 @3xl:grid-cols-2">
        <CountriesRankedCard
          onViewChange={setView}
          period={period}
          view={view}
        />
        {children}
      </div>
    </React.Fragment>
  );
}

export default CountriesSection;
